module.exports = __webpack_public_path__ + "img/ar.be7187d8.svg";